module.exports = __webpack_public_path__ + "e89cff84d83a980698cfa5e1e44f47cf.png";